module.exports = __webpack_public_path__ + "static/img/moeys.34eff1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moeys.png
// module id = AwsG
// module chunks = 1